{
  "labels": {
    "signUp": "Înscrie-te",
    "signIn": "Conectează-te",
    "paste": "Lipire",
    "pasteAsPlaintext": "Inserare ca text simplu",
    "pasteCharts": "Lipire diagrame",
    "chartType_bar": "Diagramă cu bare",
    "chartType_line": "Diagramă cu linii",
    "chartType_radar": "Diagramă radar",
    "chartType_plaintext": "Text simplu",
    "selectAll": "Selectare totală",
    "multiSelect": "Adaugă element la selecție",
    "moveCanvas": "Mutare pânză",
    "cut": "Decupare",
    "copy": "Copiere",
    "copyAsPng": "Copiere în memoria temporară ca PNG",
    "copyAsSvg": "Copiere în memoria temporară ca SVG",
    "copyText": "Copiere în memoria temporară ca text",
    "copySource": "Copiere sursă în memoria temporară",
    "convertToCode": "Convertire în cod",
    "bringForward": "Aducere în plan apropiat",
    "sendToBack": "Trimitere în ultimul plan",
    "bringToFront": "Aducere în prim plan",
    "sendBackward": "Trimitere în plan secundar",
    "delete": "Ștergere",
    "copyStyles": "Copiere stiluri",
    "pasteStyles": "Lipire stiluri",
    "stroke": "Contur",
    "changeStroke": "Modificare culoare contur",
    "background": "Fundal",
    "changeBackground": "Modificare culoare de contur",
    "fill": "Umplere",
    "strokeWidth": "Lățimea conturului",
    "strokeStyle": "Stilul conturului",
    "strokeStyle_solid": "Neîntrerupt",
    "strokeStyle_dashed": "Liniuțe",
    "strokeStyle_dotted": "Punctat",
    "sloppiness": "Aspectul trasării",
    "pressure": "Presiune",
    "pressure_constant": "Constantă",
    "pressure_variable": "Variabilă",
    "opacity": "Opacitate",
    "textAlign": "Alinierea textului",
    "edges": "Margini",
    "sharp": "Ascuțite",
    "round": "Rotunde",
    "arrowheads": "Vârfuri de săgeată",
    "arrowhead_none": "Niciunul",
    "arrowhead_arrow": "Săgeată",
    "arrowhead_bar": "Bară",
    "arrowhead_circle": "Cerc",
    "arrowhead_circle_outline": "Cerc (contur)",
    "arrowhead_triangle": "Triunghi",
    "arrowhead_triangle_outline": "Triunghi (contur)",
    "arrowhead_diamond": "Romb",
    "arrowhead_diamond_outline": "Romb (contur)",
    "arrowhead_crowfoot_many": "Model entitate-asociere (multe)",
    "arrowhead_crowfoot_one": "Model entitate-asociere (unul)",
    "arrowhead_crowfoot_one_or_many": "Model entitate-asociere (unul sau multe)",
    "arrowhead_cardinality_one": "Cardinalitate (unul)",
    "arrowhead_cardinality_many": "Cardinalitate (multe)",
    "arrowhead_cardinality_one_or_many": "Cardinalitate (unul sau multe)",
    "arrowhead_cardinality_exactly_one": "Cardinalitate (exact unul)",
    "arrowhead_cardinality_zero_or_one": "Cardinalitate (zero sau unul)",
    "arrowhead_cardinality_zero_or_many": "Cardinalitate (zero sau multe)",
    "more_options": "Mai multe opțiuni",
    "cardinality": "Cardinalitate",
    "arrowtypes": "Tip de săgeată",
    "arrowtype_sharp": "Săgeată ascuțită",
    "arrowtype_round": "Săgeată curbată",
    "arrowtype_elbowed": "Săgeată arcuită",
    "fontSize": "Dimensiune font",
    "fontFamily": "Familia de fonturi",
    "addWatermark": "Adaugă „Realizat cu Excalidraw”",
    "handDrawn": "Scris de mână",
    "normal": "Normal",
    "code": "Cod",
    "small": "Mică",
    "medium": "Medie",
    "large": "Mare",
    "veryLarge": "Foarte mare",
    "solid": "Plină",
    "hachure": "Hașură",
    "zigzag": "Zigzag",
    "crossHatch": "Hașură transversală",
    "thin": "Subțire",
    "bold": "Îngroșată",
    "left": "Stânga",
    "center": "Centru",
    "right": "Dreapta",
    "extraBold": "Extra îngroșată",
    "architect": "Arhitect",
    "artist": "Artist",
    "cartoonist": "Caricaturist",
    "fileTitle": "Nume de fișier",
    "colorPicker": "Selector de culoare",
    "canvasColors": "Folosite pe pânză",
    "canvasBackground": "Fundalul pânzei",
    "drawingCanvas": "Pânză pentru desenat",
    "clearCanvas": "Ștergere pânză",
    "layers": "Straturi",
    "actions": "Acțiuni",
    "language": "Limbă",
    "liveCollaboration": "Colaborare în direct...",
    "duplicateSelection": "Duplicare",
    "untitled": "Nedenumit",
    "name": "Nume",
    "yourName": "Numele tău",
    "madeWithExcalidraw": "Realizat cu Excalidraw",
    "group": "Grupare selecție",
    "ungroup": "Degrupare selecție",
    "collaborators": "Colaboratori",
    "you": "Tu",
    "toggleGrid": "Comutare grilă",
    "loadingScene": "Se încarcă scena…",
    "loadScene": "Încărcare scenă din fișier",
    "align": "Aliniere",
    "alignTop": "Aliniere sus",
    "alignBottom": "Aliniere jos",
    "alignLeft": "Aliniere la stânga",
    "alignRight": "Aliniere la dreapta",
    "centerVertically": "Centrare verticală",
    "centerHorizontally": "Centrare orizontală",
    "distributeHorizontally": "Distribuie orizontal",
    "distributeVertically": "Distribuie vertical",
    "flipHorizontal": "Răsturnare orizontală",
    "flipVertical": "Răsturnare verticală",
    "viewMode": "Mod de vizualizare",
    "share": "Distribuie",
    "showStroke": "Afișare selector culoare contur",
    "showBackground": "Afișare selector culoare fundal",
    "showFonts": "Afișare selector font",
    "toggleTheme": "Comutare temă luminoasă/întunecată",
    "theme": "Temă",
    "decreaseFontSize": "Micșorează dimensiunea fontului",
    "increaseFontSize": "Mărește dimensiunea fontului",
    "unbindText": "Deconectare text",
    "bindText": "Legare text de container",
    "createContainerFromText": "Încadrare text într-un container",
    "link": {
      "edit": "Editare URL",
      "editEmbed": "Editare link încorporabil",
      "create": "Adăugare link",
      "label": "URL",
      "labelEmbed": "URL și încorporare",
      "empty": "Nu este setat niciun URL",
      "hint": "Tastează-ți sau lipsește-ți linkul aici",
      "goToElement": "Accesează elementul țintă"
    },
    "lineEditor": {
      "edit": "Editare linie",
      "editArrow": "Editare săgeată"
    },
    "polygon": {
      "breakPolygon": "Întrerupere poligon",
      "convertToPolygon": "Convertire în poligon"
    },
    "elementLock": {
      "lock": "Blocare",
      "unlock": "Deblocare",
      "lockAll": "Blocare toate",
      "unlockAll": "Deblocare toate"
    },
    "sidebarLock": "Păstrează deschisă bara laterală",
    "selectAllElementsInFrame": "Selectează toate elementele din cadru",
    "removeAllElementsFromFrame": "Elimină toate elementele din cadru",
    "eyeDropper": "Alegere culoare din pânză",
    "followUs": "Urmărește-ne",
    "discordChat": "Conversații pe Discord",
    "zoomToFitViewport": "Transfocare pentru a se potrivi în poarta de vizualizare",
    "zoomToFitSelection": "Transfocare pentru a cuprinde selecția",
    "zoomToFit": "Transfocare pentru a cuprinde toate elementele",
    "installPWA": "Instalează Excalidraw la nivel local (PWA)",
    "autoResize": "Activare autoredimensionare text",
    "imageCropping": "Decupare imagine",
    "unCroppedDimension": "Dimensiune nedecupată",
    "copyElementLink": "Copiere link către obiect",
    "linkToElement": "Link către obiect",
    "wrapSelectionInFrame": "Încapsulare selecție în cadru",
    "tab": "Filă",
    "shapeSwitch": "Comutare formă",
    "preferences": "Preferințe",
    "preferences_toolLock": "Blocare instrument",
    "boxSelectionMode": "Selectare pe",
    "boxSelectionContain": "Încapsulare",
    "boxSelectionOverlap": "Suprapunere",
    "arrowBinding": "Legare săgeată",
    "midpointSnapping": "Ancorare la punctele medii"
  },
  "elementLink": {
    "title": "Link către obiect",
    "desc": "Dă clic pe o formă pe pânză sau lipește un link.",
    "notFound": "Obiectul linkuit nu a fost găsit pe pânză."
  },
  "search": {
    "title": "Găsire pe pânză",
    "noMatch": "Nicio potrivire găsită...",
    "singleResult": "rezultat",
    "multipleResults": "rezultate",
    "placeholder": "Găsire text pe pânză...",
    "frames": "Cadre",
    "texts": "Texte"
  },
  "buttons": {
    "clearReset": "Resetare pânză",
    "exportJSON": "Exportare la fișiere",
    "exportImage": "Exportare imagine...",
    "export": "Salvare în...",
    "copyToClipboard": "Copiere în memoria temporară",
    "copyLink": "Copiere link",
    "save": "Salvare în fișierul curent",
    "saveAs": "Salvare ca",
    "load": "Deschidere",
    "getShareableLink": "Obține URL partajabil",
    "close": "Închidere",
    "selectLanguage": "Selectare limbă",
    "scrollBackToContent": "Derulare înapoi la conținut",
    "zoomIn": "Apropiere",
    "zoomOut": "Depărtare",
    "resetZoom": "Resetare transfocare",
    "menu": "Meniu",
    "done": "Efectuat",
    "edit": "Editare",
    "undo": "Anulare",
    "redo": "Refacere",
    "createNewRoom": "Creare cameră nouă",
    "fullScreen": "Ecran complet",
    "darkMode": "Mod întunecat",
    "lightMode": "Mod luminos",
    "systemMode": "Mod de sistem",
    "zenMode": "Mod zen",
    "objectsSnapMode": "Ancorare la obiecte",
    "exitZenMode": "Ieșire din modul zen",
    "cancel": "Anulare",
    "clear": "Ștergere",
    "remove": "Eliminare",
    "embed": "Comutare încorporare",
    "submit": "Trimitere",
    "confirm": "Confirmare",
    "embeddableInteractionButton": "Clic pentru interacționare"
  },
  "alerts": {
    "clearReset": "Această opțiune va șterge întreaga pânză. Confirmi?",
    "couldNotCreateShareableLink": "Nu s-a putut crea un URL partajabil.",
    "couldNotCreateShareableLinkTooBig": "Nu s-a putut crea un URL partajabil: scena este prea mare",
    "couldNotLoadInvalidFile": "Fișierul invalid nu a putut fi încărcat",
    "importBackendFailed": "Importarea de la nivel de server a eșuat.",
    "cannotExportEmptyCanvas": "Nu se poate exporta pânza goală.",
    "couldNotCopyToClipboard": "Nu s-a putut copia în memoria temporară.",
    "decryptFailed": "Datele nu au putut fi decriptate.",
    "uploadedSecurly": "Încărcarea a fost securizată prin criptare integrală, însemnând că serverul Excalidraw și terții nu pot citi conținutul.",
    "loadSceneOverridePrompt": "Încărcarea desenului extern va înlocui conținutul existent. Dorești să continui?",
    "collabStopOverridePrompt": "Oprirea sesiunii va suprascrie desenul anterior stocat local. Confirmi alegerea?\n\n(Dacă vrei să păstrezi desenul local, pur și simplu închide fila navigatorului în schimb.)",
    "imageDoesNotContainScene": "Această imagine nu pare să conțină date de scenă. Ai activat încorporarea scenei în timpul exportului?",
    "cannotRestoreFromImage": "Scena nu a putut fi restaurată din acest fișier de imagine",
    "invalidSceneUrl": "Scena nu a putut fi importată din URL-ul furnizat. Este fie incorect formată, fie nu conține date JSON Excalidraw valide.",
    "invalidEncryptionKey": "Cheia de criptare trebuie să aibă 22 de caractere. Colaborarea în direct este dezactivată.",
    "collabOfflineWarning": "Nu este disponibilă nicio conexiune la internet.\nModificările nu vor fi salvate!",
    "localStorageQuotaExceeded": "Cota pentru spațiul de stocare al navigatorului a fost depășită. Modificările nu vor fi salvate."
  },
  "errors": {
    "unsupportedFileType": "Tip de fișier neacceptat.",
    "imageInsertError": "Imaginea nu a putut fi introdusă. Reîncearcă mai târziu...",
    "fileTooBig": "Fișierul este prea mare. Dimensiunea maximă permisă este de {{maxSize}}.",
    "svgImageInsertError": "Imaginea SVG nu a putut fi introdus. Marcajul SVG pare invalid.",
    "failedToFetchImage": "Preluarea imaginii a eșuat.",
    "cannotResolveCollabServer": "Nu a putut fi realizată conexiunea la serverul de colaborare. Reîncarcă pagina și încearcă din nou.",
    "collabSaveFailed": "Nu s-a putut salva în baza de date la nivel de server. Dacă problemele persistă, ar trebui să salvezi fișierul la nivel local pentru a te asigura că nu îți pierzi munca.",
    "collabSaveFailed_sizeExceeded": "Nu s-a putut salva în baza de date la nivel de server, întrucât se pare că pânza este prea mare. Ar trebui să salvezi fișierul la nivel local pentru a te asigura că nu îți pierzi munca.",
    "imageToolNotSupported": "Imaginile sunt dezactivate.",
    "brave_measure_text_error": {
      "line1": "Se pare că folosești navigatorul Brave cu opțiunea <bold>strictă pentru blocarea amprentării</bold>.",
      "line2": "Acest lucru poate duce la întreruperea <bold>elementelor text</bold> din desene.",
      "line3": "Îți recomandăm ferm să dezactivezi această setare. Poți urma <link>acești pași</link> pentru a face acest lucru.",
      "line4": "Dacă dezactivarea acestei setări nu duce la remedierea afișării elementelor text, deschide un tichet de <issueLink>problemă</issueLink> pe pagina noastră de GitHub sau scrie-ne pe <discordLink>Discord</discordLink>"
    },
    "asyncPasteFailedOnRead": "Lipirea nu a putut fi efectuată (nu s-a putut citit din memoria temporară a sistemului).",
    "asyncPasteFailedOnParse": "Lipirea nu a putut fi efectuată.",
    "copyToSystemClipboardFailed": "Nu s-a putut copia în memoria temporară."
  },
  "toolBar": {
    "selection": "Selecție",
    "lasso": "Selecție lasou",
    "image": "Introducere imagine",
    "rectangle": "Dreptunghi",
    "diamond": "Romb",
    "ellipse": "Elipsă",
    "arrow": "Săgeată",
    "line": "Linie",
    "freedraw": "Desenare",
    "text": "Text",
    "lock": "Menține activ instrumentul selectat după desenare",
    "penMode": "Mod stilou – împiedică atingerea",
    "link": "Adăugare/actualizare link pentru o formă selectată",
    "eraser": "Radieră",
    "frame": "Instrument cadru",
    "embeddable": "Încorporare web",
    "laser": "Indicator laser",
    "autoshape": "Desenează la formă",
    "bucketfill": "Umplere cu culoare",
    "hand": "Mână (instrument de panoramare)",
    "extraTools": "Mai multe instrumente",
    "convertElementType": "Comutare tip formă"
  },
  "bucketfill": {
    "noRegion": "Nu s-a putut găsi o regiune închisă pentru a o umple aici.",
    "tooComplex": "Această regiune este prea complexă pentru a fi umplută."
  },
  "element": {
    "rectangle": "Dreptunghi",
    "diamond": "Romb",
    "ellipse": "Elipsă",
    "arrow": "Săgeată",
    "line": "Linie",
    "freedraw": "Desenare liberă",
    "text": "Text",
    "image": "Imagine",
    "group": "Grup",
    "frame": "Cadru",
    "embeddable": "Încorporare web",
    "selection": "Selecție",
    "iframe": "iFrame"
  },
  "headings": {
    "canvasActions": "Acțiuni pentru pânză",
    "selectedShapeActions": "Acțiuni pentru forma selectată",
    "shapes": "Forme"
  },
  "hints": {
    "dismissSearch": "{{shortcut}} pentru a închide căutarea",
    "canvasPanning": "Pentru a muta pânză, ține {{shortcut_1}} sau {{shortcut_2}} în timp ce glisezi sau folosește instrumentul în formă de mână",
    "linearElement": "Dă clic pentru a crea mai multe puncte, glisează pentru a forma o singură linie",
    "arrowTool": "Dă clic pentru a crea mai multe puncte, glisează pentru a forma o singură linie. Apasă {{shortcut}} din nou pentru a modifica tipul săgeții.",
    "arrowBindModifiers": "Ține apăsat {{shortcut_1}} pentru a dezactivarea legarea sau {{shortcut_2}} pentru a efectua legarea la un punct fix",
    "freeDraw": "Dă clic pe pânză și glisează cursorul, apoi eliberează-l când ai terminat",
    "text": "Sfat: poți adăuga text și dând dublu clic oriunde cu instrumentul de selecție",
    "embeddable": "Dă clic și trage pentru a crea un cod de încorporare de pagină web",
    "autoshape": "Desenează dreptunghiuri, cercuri, romburi, linii și săgeți",
    "text_selected": "Dă dublu clic sau apasă {{shortcut}} pentru a edita textul",
    "text_editing": "Apasă {{shortcut_1}} sau {{shortcut_2}} pentru a finaliza editarea",
    "linearElementMulti": "Dă clic pe ultimul punct sau apasă {{shortcut_1}} sau {{shortcut_2}} pentru a finaliza",
    "lockAngle": "Poți constrânge unghiul prin ținerea apăsată a {{shortcut}}",
    "resize": "Poți constrânge proporțiile, ținând apăsat {{shortcut_1}} în timp ce redimensionezi,\nține apăsat {{shortcut_2}} pentru a redimensiona de la centru",
    "resizeImage": "Poți constrânge proporțiile, ținând apăsat {{shortcut_1}},\nține apăsat {{shortcut_2}} pentru a redimensiona de la centru",
    "rotate": "Poți constrânge unghiurile, ținând apăsat {{shortcut}} în timp ce rotești",
    "toggleArrowhead": "Dă dublu clic pentru a comuta săgeta",
    "lineEditor_info": "Ține apăsat {{shortcut_1}} și dă dublu clic sau apasă {{shortcut_2}} pentru a edita punctele",
    "lineEditor_line_info": "Dă dublu clic sau apasă {{shortcut}} pentru a edita punctele",
    "lineEditor_pointSelected": "Apasă {{shortcut_1}} pentru a elimina punctele,\n{{shortcut_2}} pentru a duplica sau glisează pentru a muta",
    "lineEditor_nothingSelected": "Selectează un punct pentru a-l edita (ține apăsat {{shortcut_1}} pentru a selecta mai multe),\nsau ține apăsat {{shortcut_2}} și dă clic pentru a adăuga puncte noi",
    "bindTextToElement": "{{shortcut}} pentru a adăuga text",
    "createFlowchart": "{{shortcut}} pentru a crea o schemă logică",
    "deepBoxSelect": "Ține apăsat {{shortcut}} pentru a efectua selectarea de adâncime și pentru a preveni glisarea",
    "eraserRevert": "Ține apăsat {{shortcut}} pentru a anula elementele marcate pentru ștergere",
    "firefox_clipboard_write": "Această caracteristică poate fi probabil activată prin setarea preferinței „dom.events.asyncClipboard.clipboardItem” ca „true”. Pentru a schimba preferințele navigatorului în Firefox, accesează pagina „about:config”.",
    "disableSnapping": "Ține apăsat {{shortcut}} pentru a dezactiva ancorarea",
    "enterCropEditor": "Dă dublu clic pe imagine sau apasă {{shortcut}} pentru a decupa imaginea",
    "leaveCropEditor": "Dă clic în afara imaginii sau apasă {{shortcut_1}} sau {{shortcut_2}} pentru a finaliza decuparea"
  },
  "canvasError": {
    "cannotShowPreview": "Nu se poate afișa previzualizarea",
    "canvasTooBig": "Pânza poate fi prea mare.",
    "canvasTooBigTip": "Sfat: încearcă să apropii puțin mai mult elementele cele mai îndepărtate."
  },
  "errorSplash": {
    "headingMain": "A apărut o eroare. Încearcă <button>să reîncarci pagina</button>.",
    "clearCanvasMessage": "Dacă reîncărcarea nu funcționează, încearcă <button>să ștergi pânza</button>.",
    "clearCanvasCaveat": " Acest lucru va duce la pierderea progresului ",
    "trackedToSentry": "Eroarea cu identificatorul {{eventId}} a fost urmărită în sistemul nostru.",
    "openIssueMessage": "Am luat măsuri de precauție pentru a nu include informații despre scenă în eroare. Dacă scena nu este privată, oferă-ne mai multe informații în <button>monitorul nostru pentru erori</button>. Include informațiile de mai jos copiindu-le și lipindu-le în tichetul cu problemă de pe GitHub.",
    "sceneContent": "Conținutul scenei:"
  },
  "shareDialog": {
    "or": "Sau"
  },
  "roomDialog": {
    "desc_intro": "Invită persoane să colaboreze la desenul tău.",
    "desc_privacy": "Nu-ți face griji, sesiunea este criptată integral și complet privată. Nici măcar serverul nostru nu poate vedea ce desenezi.",
    "button_startSession": "Pornire sesiune",
    "button_stopSession": "Oprire sesiune",
    "desc_inProgressIntro": "Sesiunea de colaborare în direct este în curs de desfășurare.",
    "desc_shareLink": "Distribuie acest URL persoanelor cu care dorești să colaborezi:",
    "desc_exitSession": "Oprirea sesiunii te va deconecta de la sală, însă vei putea lucra în continuare, pe plan local, cu scena. Reține că această opțiune nu va afecta alte persoane, iar acestea vor putea să colaboreze în continuare pe versiunea lor.",
    "shareTitle": "Alătură-te unei sesiuni de colaborare în direct pe Excalidraw"
  },
  "errorDialog": {
    "title": "Eroare"
  },
  "progressDialog": {
    "title": "În curs de salvare",
    "defaultMessage": "Se pregătește salvarea..."
  },
  "exportDialog": {
    "disk_title": "Salvare pe disc",
    "disk_details": "Exportă datele scenei pe un fișier din care poți importa mai târziu.",
    "disk_button": "Salvare în fișier",
    "link_title": "URL partajabil",
    "link_details": "Exportă ca URL doar în citire.",
    "link_button": "Exportare în URL",
    "excalidrawplus_description": "Salvează scena în spațiul de lucru Excalidraw+.",
    "excalidrawplus_button": "Exportare",
    "excalidrawplus_exportError": "Excalidraw+ nu a putut fi exportat în acest moment..."
  },
  "helpDialog": {
    "blog": "Citește blogul nostru",
    "click": "clic",
    "deepSelect": "Selectare de adâncime",
    "deepBoxSelect": "Selectare de adâncime în casetă și prevenire glisare",
    "createFlowchart": "Crează o schemă logică dintr-un element generic",
    "navigateFlowchart": "Navighează o schemă logică",
    "curvedArrow": "Săgeată curbată",
    "curvedLine": "Linie curbată",
    "documentation": "Documentație",
    "doubleClick": "dublu clic",
    "drag": "glisare",
    "editor": "Editor",
    "editLineArrowPoints": "Editare puncte de săgeată/rând",
    "editText": "Editare text/adăugare etichetă",
    "github": "Ai întâmpinat o problemă? Trimite un raport",
    "howto": "Urmărește ghidurile noastre",
    "or": "sau",
    "preventBinding": "Împiedică legarea săgeții",
    "tools": "Instrumente",
    "shortcuts": "Comenzi rapide de la tastatură",
    "textFinish": "Finalizează editarea (editor de text)",
    "textNewLine": "Adaugă o linie nouă (editor de text)",
    "title": "Ajutor",
    "view": "Vizualizare",
    "zoomToFit": "Transfocare pentru a cuprinde toate elementele",
    "zoomToSelection": "Transfocare la selecție",
    "toggleElementLock": "Blocare/deblocare selecție",
    "movePageUpDown": "Deplasare pagină sus/jos",
    "movePageLeftRight": "Deplasare pagină stânga/dreapta",
    "cropStart": "Decupare imagine",
    "cropFinish": "Finalizare decupare imagine"
  },
  "clearCanvasDialog": {
    "title": "Ștergere pânză"
  },
  "imageExportDialog": {
    "header": "Exportare imagine",
    "label": {
      "withBackground": "Fundal",
      "onlySelected": "Numai selecția",
      "darkMode": "Mod întunecat",
      "embedScene": "Încorporare scenă",
      "scale": "Scală",
      "padding": "Spațiere"
    },
    "tooltip": {
      "embedScene": "Datele scenei vor fi salvate în fișierul PNG/SVG exportat, astfel că scena va putea fi restaurată din acesta.\nVa crește dimensiunea fișierului exportat."
    },
    "title": {
      "exportToPng": "Exportare ca PNG",
      "exportToSvg": "Exportare ca SVG",
      "copyPngToClipboard": "Copiere PNG în memoria temporară"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Copiere în memoria temporară"
    }
  },
  "encrypted": {
    "tooltip": "Desenele tale sunt criptate integral, astfel că serverele Excalidraw nu le vor vedea niciodată.",
    "link": "Articol de blog pe criptarea integrală din Excalidraw"
  },
  "stats": {
    "angle": "Unghi",
    "shapes": "Forme",
    "height": "Înălțime",
    "scene": "Scenă",
    "selected": "Selectate",
    "storage": "Stocare",
    "fullTitle": "Proprietăți pentru pânză și forme",
    "title": "Proprietăți",
    "generalStats": "General",
    "elementProperties": "Proprietăți pentru forme",
    "total": "Total",
    "version": "Versiune",
    "versionCopy": "Clic pentru copiere",
    "versionNotAvailable": "Versiune indisponibilă",
    "width": "Lățime"
  },
  "toast": {
    "copyStyles": "Stiluri copiate.",
    "copyToClipboard": "Copiat în memoria temporară.",
    "copyToClipboardAsPng": "S-a copiat {{exportSelection}} în memoria temporară sub formă de PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "S-a copiat {{exportSelection}} în memoria temporară sub formă de SVG\n({{exportColorScheme}})",
    "fileSaved": "Fișier salvat.",
    "fileSavedToFilename": "Salvat în {filename}",
    "canvas": "pânza",
    "selection": "selecția",
    "pasteAsSingleElement": "Folosește {{shortcut}} pentru a insera ca un singur element\nsau insera într-un editor de text existent",
    "unableToEmbed": "Încorporarea acestui URL nu este permisă momentan. Deschideți un tichet cu probleme pe GitHub pentru a solicita adăugarea acestui URL în lista albă",
    "unrecognizedLinkFormat": "URL-ul pe care l-ai încorporat nu coincide cu formatul așteptat. Încearcă să lipești șirul „de încorporat” furnizat de pagina sursă",
    "elementLinkCopied": "Link copiat în memoria temporară"
  },
  "colors": {
    "transparent": "Transparent",
    "black": "Negru",
    "white": "Alb",
    "red": "Roșu",
    "pink": "Roz",
    "grape": "Struguriu",
    "violet": "Violet",
    "gray": "Gri",
    "blue": "Albastru",
    "cyan": "Cyan",
    "teal": "Cyan-verde",
    "green": "Verde",
    "yellow": "Galben",
    "orange": "Portocaliu",
    "bronze": "Bronz"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Desenele tale sunt salvate în spațiul de stocare al navigatorului tău.",
      "center_heading_line2": "Spațiul de stocare al navigatorului poate fi șters în mod neașteptat.",
      "center_heading_line3": "Salvează-ți periodic munca într-un fișier pentru a evita pierderea acesteia.",
      "center_heading_plus": "Ai vrut să mergi în schimb la Excalidraw+?",
      "menuHint": "Exportare, preferințe, limbi, ..."
    },
    "defaults": {
      "menuHint": "Exportare, preferințe și mai multe...",
      "center_heading": "Diagrame. Făcute. Simple.",
      "toolbarHint": "Alege un instrument și începe să desenezi!",
      "helpHint": "Comenzi rapide și ajutor"
    }
  },
  "colorPicker": {
    "color": "Culoare",
    "mostUsedCustomColors": "Cele mai utilizate culori personalizate",
    "colors": "Culori",
    "shades": "Nuanțe",
    "hexCode": "Cod hexa",
    "noShades": "Nu este disponibilă nicio nuanță pentru această culoare",
    "invalidColor": "Nu este o culoare validă",
    "invalidHexLength": "Codul hexazecimal trebuie să fie alcătuit din 3, 4, 6 sau 8 caractere",
    "topPicksTip": "Sfat: trage orice culoare la alegerile tale principale pentru a o fixa",
    "resetTopPicks": "Resetare la alegerile principale implicite"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exportare ca imagine",
        "button": "Exportare ca imagine",
        "description": "Exportă datele scenei ca fișier din care poți importa mai târziu."
      },
      "saveToDisk": {
        "title": "Salvare pe disc",
        "button": "Salvare pe disc",
        "description": "Exportă datele scenei pe un fișier din care poți importa mai târziu."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exportare în Excalidraw+",
        "description": "Salvează scena în spațiul de lucru Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Încărcare din fișier",
        "button": "Încărcare din fișier",
        "description": "Încărcarea dintr-un fișier va <bold>înlocui conținutul existent</bold>.<br></br>Poți face mai întâi o copie de rezervă a desenului folosind una dintre opțiunile de mai jos."
      },
      "shareableLink": {
        "title": "Încărcare din lnk",
        "button": "Înlocuiește conținutul meu",
        "description": "Încărcarea unui desen extern va <bold>înlocui conținutul existent</bold>.<br></br>Poți face mai întâi o copie de rezervă a desenului folosind una dintre opțiunile de mai jos."
      }
    }
  },
  "quickSearch": {
    "placeholder": "Căutare rapidă"
  },
  "fontList": {
    "badge": {
      "old": "vechi"
    },
    "sceneFonts": "În această scenă",
    "availableFonts": "Fonturi disponibile",
    "empty": "Niciun font găsit"
  },
  "userList": {
    "empty": "Niciun utilizator găsit",
    "hint": {
      "text": "Dă clic pe un utilizator pentru a-l urmări",
      "followStatus": "În prezent urmărești acest utilizator",
      "inCall": "Utilizatorul este angajat într-un apel vocal",
      "micMuted": "Microfonul utilizatorul este pus pe mut",
      "isSpeaking": "Utilizatorul vorbește"
    }
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Opțiune",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Enter",
    "shift": "Shift",
    "spacebar": "Space",
    "delete": "Delete",
    "mmb": "Rotiță maus"
  }
}
